import { render, staticRenderFns } from "./FileDisplay.vue?vue&type=template&id=25f613d8&"
import script from "./FileDisplay.vue?vue&type=script&lang=js&"
export * from "./FileDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports